import { jsx as _jsx } from "react/jsx-runtime";
import { useWatch } from 'react-hook-form';
import { ServiceItemView } from './service-item';
export var ServiceItemContainer = function (_a) {
    var service = _a.service, form = _a.form;
    var formValue = useWatch({
        control: form.control,
        name: "services.".concat(service.id),
    });
    var toggleService = function () {
        form.setValue("services.".concat(service.id), !formValue);
    };
    return _jsx(ServiceItemView, { service: service, isSelected: formValue, onClick: toggleService });
};
